import { INTERFACE } from '@/utils/INTERFACE';
import { getPlatform, isApp } from '@/utils/page'
import { getParams as getUrlParams } from '@/utils/urlQuery'
import Cookies from 'js-cookie';
import { getSystem } from '@/utils/site'

export function loginJump() {
	let { platform } = getPlatform()
	if (isApp() && INTERFACE().login['app']) {
		platform = 'app'
	}
	let url=INTERFACE().login[platform]

	// 内嵌页外部跳转逻辑
	if (getUrlParams().iframe) {
		window.parent.location.href = url
		return
	}

	location.href = url
}

export function isLogin(){
	if(getSystem()=='EJSHOP'){
		return !!Cookies.get('ptkey')
	}
	return !!Cookies.get('pin')
}